import { createApp } from "vue";
import App from "./App.vue";

const app = createApp({
  components: {
    App,
  },
  methods: {},
  mounted() {
    //console.log(configurator);
  },
  template: `<App 
  />`,
});

if (document.querySelector("#app")) {
  app.mount("#app");
}
